const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  IS_PRODUCTION: import.meta.env.VITE_ENVIRONMENT === 'production',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  CLARITY_ID: import.meta.env.VITE_CLARITY_ID,
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '',
  GOOGLE_MAPS_MAP_ID: import.meta.env.VITE_GOOGLE_MAPS_API_ID ?? ''
}

export default env
